export default __webpack_public_path__ + "static/media/Kal Gum.c1026af5.jpg";